import axios from "axios";
import { Constants, Helpers } from "utils";

/**
 * responsible for creating the instance of axios in order to make requests to our server
 */

export const qubehub = (accessToken?: string) =>
  axios.create({
    baseURL: Constants.API_URL,
    headers: {
      common: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  });

/**
 * responsible for creating the instance of axios in order to make requests to the Google API (0auth2)
 */

export const google = (baseUrl: string, params: object) =>
  axios.create({
    baseURL: Helpers.interpolate(baseUrl, params),
  });

/**
 * responsible for creating the instance of axios in order to make requests to Google Calendar API
 */

export const calendar = (baseUrl: string, token: string, params: object = {}) =>
  axios.create({
    baseURL: Helpers.interpolate(baseUrl, params),
    headers: {
      common: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
